// src/components/ResumeTemplates.js
/**
 * Resume templates in HTML format
 * Each template function takes resumeData and returns HTML
 */

// Import templates from individual files
import {
  standardTemplateHtml,
  modernTemplateHtml,
  minimalistTemplateHtml,
  // executiveTemplateHtml,
  templates,
  getTemplates,
} from "./resumeTemplates/index";

// Re-export all templates and functions
export {
  standardTemplateHtml,
  modernTemplateHtml,
  minimalistTemplateHtml,
  // executiveTemplateHtml,
  templates,
  getTemplates,
};

export default templates;
